import { render, staticRenderFns } from "./onChange-editor.vue?vue&type=template&id=47007b06&scoped=true"
import script from "./onChange-editor.vue?vue&type=script&lang=js"
export * from "./onChange-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47007b06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47007b06')) {
      api.createRecord('47007b06', component.options)
    } else {
      api.reload('47007b06', component.options)
    }
    module.hot.accept("./onChange-editor.vue?vue&type=template&id=47007b06&scoped=true", function () {
      api.rerender('47007b06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/event-handler/onChange-editor.vue"
export default component.exports